import React from "react";

import styles from "./Guides.module.css";

const CanvasCenterGuides = () => (
  <>
    <rect
      className={`${styles.canvasCenterGuide} ${styles.canvasCenterGuideV}`}
    />
    <rect
      className={`${styles.canvasCenterGuide} ${styles.canvasCenterGuideH}`}
    />
  </>
);

export default CanvasCenterGuides;
